import React from 'react'
import LeadBanner from './LeadBanner'
import MiniRedirection from './MiniRedirection'
import ThirdSection from './ThirdSection'
import FourthSection from './FourthSection'
import FithSection from './FithSection'
import HomeFlight from '../home/HomeFlight'
import SeeBeautiful from '../hotel/SeeBeautiful'
import Tours from '../hotel/Tours'
import SoloTravelForm from './SoloTravelForm'
import FAQ from './FAQ'

export default function index() {
  return (
    <>
      <LeadBanner/>
      <MiniRedirection/>
      <ThirdSection/>
      <FourthSection/>
      <FithSection/>
      <HomeFlight/>
      <Tours/>
      <SeeBeautiful/>
      <SoloTravelForm/>
      <FAQ/>
    </>
  )
}
